module.exports = __webpack_public_path__ + "img/02.386ab64e.png";